import { isNullOrUndefined, isPositiveNumber } from "et3-type-guards";
import { memoize } from "lodash";
import { apiCallCleanAdminPoolByType } from "../../../api/core-api/api-call-clean-admin-pool";
import { TCorePage, TPoolTable } from "../../../Types";
import getCorePopUpStore from "../core-popup-store";
import getCoreUIStore from "../core-ui-store";
import getApproveRejectStore from "../../approval-reject-store";
import getReportsStore from "../../reports-store";
import getInvestigationCasesStore from "../../investigation-cases-store";
import getAuditStore from "../../auditor-store/audit-store";

class CleanPoolStore {
  cleanPool = async <T>({
    currentData,
    page,
    poolType,
    successVoidFunction
  }: {
    currentData: T | T[];
    page: TCorePage;
    poolType: TPoolTable;
    successVoidFunction: () => void;
  }) => {
    if (!isNullOrUndefined(currentData)) {
      getCoreUIStore().setIsLoading(page, true);
      const { status, data, code } = await apiCallCleanAdminPoolByType({
        poolType
      });
      if (status === "OK" && isPositiveNumber(data)) {
        successVoidFunction();
      } else {
        successVoidFunction();
        getCorePopUpStore().showAlertMessage(code);
      }
      getCoreUIStore().setIsLoading(page, false);
    }
  };
  automaticCleanPool = async ({ type }: { type: TPoolTable }) => {
    switch (type) {
      case "APPROVAL":
        getApproveRejectStore().setApprovalData([]);
        break;
      case "REPORT":
        getReportsStore().cleanReports();
      case "INVESTIGATION_CASES":
        getInvestigationCasesStore().setInvestigationCases([]);
      case "AUDITOR_AUDIT_EVENTS":
        getAuditStore().resetAll();
      default:
        break;
    }
  };
}
const getCleanPoolStore = memoize(
  () => new CleanPoolStore(),
  () => 1
);
export default getCleanPoolStore;
